module.exports = __webpack_public_path__ + "static/media/creative-sales.ac53091a.jpg";